// import sidebar from '@/config/sidebars/geobooster'
// import createVueApp from '@/common/createApp'

Styxie.Initializers.MobileServiceTitanJobs = {
  // Phase 2: Jobs Index
  // index: async(props) => { ... }

  // Phase 2: Job Show
  // show: async(props) => { ... }
}
